module.exports = __webpack_public_path__ + "cf2e4a8fe0b9f86540f63829550259fa.jpg";